import React, { useEffect, useState } from 'react';
import { isLoggedIn, signIn } from "@mirats/mirats-auth";
import { LoadingPage } from './LoadingPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = isLoggedIn();
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Add a small delay to show the loading state
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        if (user && !loading) {
          console.log("User authenticated:", { user, loading });
          setIsInitializing(false);
        } else {
          console.log("No user found, redirecting to sign in");
          signIn();
        }
      } catch (error) {
        console.error("Auth check error:", error);
        signIn();
      }
    };

    checkAuth();
  }, [user, loading]);

  // Show loading page during initialization
  if (isInitializing || loading) {
    return <LoadingPage />;
  }

  // If we have a user, render the children
  if (user) {
    return <>{children}</>;
  }

  // This should not be reached due to signIn() call above
  return <LoadingPage />;
}; 